module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_onboard_evaluate-4ef5e66a390c2dbfe147433026a0767b.svg";